import React from "react";
import {
  Modal,
  Grid,
  Typography,
  Button,
  Box,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import psychometricPhoto from "../../../assets/SAP-Dashboard/PsychometricModal/psychometric.png";

export default function PsychometricTestModal({ open, handleClose }) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Grid
        container
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          borderRadius: "12px",
          width: 950,
          p: 3,
          boxShadow: 24,
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            zIndex: 2,
            position: "absolute",
            top: -16,
            right: -16,
            backgroundColor: "#CE0E00",
            color: "white",
            "&:hover": { backgroundColor: "#A50C00" },
            boxShadow: "0px 2px 6px rgba(0,0,0,0.2)",
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* HEADER */}

        <Grid
          sx={{
            gap: 1.5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "#F4DDF4",
            borderRadius: "6px",
            px: 2.5,
            py: 0,
          }}
        >
          <Grid item>
            <svg
              width="25"
              height="26"
              viewBox="0 0 25 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.0766 3.41553C19.2934 2.85598 16.6156 1.86174 14.1416 0.469349C13.617 0.162007 13.02 0 12.412 0C11.804 0 11.2069 0.162007 10.6823 0.469349C8.20835 1.86174 5.5306 2.85598 2.74741 3.41553C1.97423 3.5784 1.28008 4.00096 0.780308 4.61297C0.280541 5.22499 0.00526374 5.9896 0.000228025 6.77973V8.96747C-0.0151428 11.996 0.746819 14.9779 2.21323 17.6278C3.67964 20.2777 5.80145 22.5071 8.37569 24.1026L10.5947 25.4793C11.1389 25.8196 11.7677 26 12.4095 26C13.0512 26 13.6801 25.8196 14.2242 25.4793L16.442 24.1026C19.0174 22.5079 21.1405 20.2788 22.608 17.6289C24.0755 14.9789 24.8384 11.9966 24.8237 8.96747V6.77973C24.8187 5.9896 24.5434 5.22499 24.0437 4.61297C23.5439 4.00096 22.8497 3.5784 22.0766 3.41553Z"
                fill="#F1B95C"
              />
              <path
                d="M13.6645 15.183C13.5412 15.1833 13.4191 15.1592 13.3052 15.1119C13.1913 15.0646 13.088 14.9952 13.0012 14.9077L10.498 12.4046C10.3322 12.2266 10.2419 11.9913 10.2462 11.7481C10.2505 11.5049 10.349 11.2729 10.521 11.1009C10.693 10.9289 10.925 10.8304 11.1682 10.8261C11.4114 10.8218 11.6467 10.9121 11.8247 11.0779L13.6645 12.9165L19.259 7.32322C19.4369 7.15741 19.6723 7.06714 19.9154 7.07144C20.1586 7.07573 20.3906 7.17424 20.5626 7.34622C20.7346 7.5182 20.8331 7.75022 20.8374 7.9934C20.8417 8.23658 20.7514 8.47193 20.5856 8.64988L14.3278 14.9077C14.241 14.9952 14.1376 15.0646 14.0238 15.1119C13.9099 15.1592 13.7878 15.1833 13.6645 15.183Z"
                fill="#FCC400"
              />
              <path
                d="M12.4106 18.312C11.4463 18.3137 10.496 18.0808 9.64167 17.6333C8.78738 17.1859 8.05478 16.5373 7.50704 15.7436C6.9593 14.9499 6.61288 14.0348 6.49766 13.0773C6.38244 12.1199 6.50188 11.1487 6.84567 10.2477C7.18946 9.34671 7.74729 8.54286 8.47103 7.90551C9.19477 7.26816 10.0627 6.81644 11 6.58933C11.9372 6.36222 12.9156 6.36652 13.8508 6.60187C14.7861 6.83723 15.65 7.29656 16.3681 7.94026C16.4688 8.01973 16.5521 8.119 16.6129 8.23193C16.6737 8.34486 16.7108 8.46906 16.7217 8.59686C16.7327 8.72466 16.7173 8.85335 16.6766 8.97499C16.6359 9.09663 16.5707 9.20863 16.485 9.30408C16.3993 9.39953 16.295 9.47641 16.1784 9.52997C16.0619 9.58353 15.9356 9.61263 15.8074 9.61548C15.6791 9.61833 15.5517 9.59487 15.4328 9.54654C15.314 9.49822 15.2064 9.42605 15.1165 9.3345C14.3741 8.6659 13.4097 8.29702 12.4106 8.29945C11.3319 8.29945 10.2973 8.728 9.53443 9.49082C8.77161 10.2536 8.34306 11.2882 8.34306 12.367C8.34306 13.4458 8.77161 14.4804 9.53443 15.2433C10.2973 16.0061 11.3319 16.4346 12.4106 16.4346C12.6244 16.4331 12.8378 16.4155 13.0489 16.3821C13.4371 16.3207 13.8139 16.2013 14.1666 16.0279C14.9995 15.632 15.6708 14.9616 16.0677 14.1292C16.1746 13.9044 16.3664 13.7311 16.601 13.6477C16.8356 13.5643 17.0938 13.5774 17.3187 13.6843C17.5435 13.7912 17.7168 13.983 17.8002 14.2176C17.8836 14.4522 17.8705 14.7104 17.7636 14.9352C17.182 16.1548 16.1994 17.1378 14.9801 17.72C14.459 17.9746 13.9025 18.1492 13.3293 18.2381C13.0253 18.2855 12.7183 18.3102 12.4106 18.312Z"
                fill="white"
              />
              <path
                d="M22.0766 3.41553C19.2934 2.85598 16.6156 1.86174 14.1416 0.469349C13.617 0.162007 13.02 0 12.412 0C11.804 0 11.2069 0.162007 10.6823 0.469349C8.20835 1.86174 5.5306 2.85598 2.74741 3.41553C1.97423 3.5784 1.28008 4.00096 0.780308 4.61297C0.280541 5.22499 0.00526374 5.9896 0.000228025 6.77973V8.96747C-0.0151428 11.996 0.746819 14.9779 2.21323 17.6278C3.67964 20.2777 5.80145 22.5071 8.37569 24.1026L10.5947 25.4793C11.1389 25.8196 11.7677 26 12.4095 26C13.0512 26 13.6801 25.8196 14.2242 25.4793L16.442 24.1026C19.0174 22.5079 21.1405 20.2788 22.608 17.6289C24.0755 14.9789 24.8384 11.9966 24.8237 8.96747V6.77973C24.8187 5.9896 24.5434 5.22499 24.0437 4.61297C23.5439 4.00096 22.8497 3.5784 22.0766 3.41553Z"
                fill="#F1B95C"
              />
              <path
                d="M12.4106 18.312C11.4463 18.3137 10.496 18.0808 9.64167 17.6333C8.78738 17.1859 8.05478 16.5373 7.50704 15.7436C6.9593 14.9499 6.61288 14.0348 6.49766 13.0773C6.38244 12.1199 6.50188 11.1487 6.84567 10.2477C7.18946 9.34671 7.74729 8.54286 8.47103 7.90551C9.19477 7.26816 10.0627 6.81644 11 6.58933C11.9372 6.36222 12.9156 6.36652 13.8508 6.60187C14.7861 6.83723 15.65 7.29656 16.3681 7.94026C16.4688 8.01973 16.5521 8.119 16.6129 8.23193C16.6737 8.34486 16.7108 8.46906 16.7217 8.59686C16.7327 8.72466 16.7173 8.85335 16.6766 8.97499C16.6359 9.09663 16.5707 9.20863 16.485 9.30408C16.3993 9.39953 16.295 9.47641 16.1784 9.52997C16.0619 9.58353 15.9356 9.61263 15.8074 9.61548C15.6791 9.61833 15.5517 9.59487 15.4328 9.54654C15.314 9.49822 15.2064 9.42605 15.1165 9.3345C14.3741 8.6659 13.4097 8.29702 12.4106 8.29945C11.3319 8.29945 10.2973 8.728 9.53443 9.49082C8.77161 10.2536 8.34306 11.2882 8.34306 12.367C8.34306 13.4458 8.77161 14.4804 9.53443 15.2433C10.2973 16.0061 11.3319 16.4346 12.4106 16.4346C12.6244 16.4331 12.8378 16.4155 13.0489 16.3821C13.4371 16.3207 13.8139 16.2013 14.1666 16.0279C14.9995 15.632 15.6708 14.9616 16.0677 14.1292C16.1746 13.9044 16.3664 13.7311 16.601 13.6477C16.8356 13.5643 17.0938 13.5774 17.3187 13.6843C17.5435 13.7912 17.7168 13.983 17.8002 14.2176C17.8836 14.4522 17.8705 14.7104 17.7636 14.9352C17.182 16.1548 16.1994 17.1378 14.9801 17.72C14.459 17.9746 13.9025 18.1492 13.3293 18.2381C13.0253 18.2855 12.7183 18.3102 12.4106 18.312Z"
                fill="white"
              />
              <path
                d="M2.94072 4.33416C5.82047 3.75158 8.59121 2.72158 11.1522 1.2816C11.5348 1.05864 11.9697 0.941162 12.4126 0.941162C12.8554 0.941162 13.2903 1.05864 13.6729 1.2816C16.2339 2.72158 19.0046 3.75158 21.8844 4.33416C22.4485 4.44931 22.9557 4.75542 23.3205 5.20089C23.6852 5.64636 23.8853 6.20396 23.8869 6.77972V8.96745C23.8914 11.8347 23.1653 14.6558 21.7772 17.1646C20.3891 19.6734 18.3848 21.7872 15.9532 23.3066L13.7355 24.6833C13.3388 24.93 12.8809 25.0607 12.4138 25.0607C11.9467 25.0607 11.4889 24.93 11.0922 24.6833L8.87439 23.3066C6.44261 21.7874 4.438 19.6736 3.04968 17.1648C1.66137 14.656 0.935122 11.8348 0.939473 8.96745V6.77972C0.941023 6.20414 1.14089 5.64667 1.50541 5.20123C1.86993 4.75578 2.37683 4.44957 2.94072 4.33416Z"
                stroke="#2A3330"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.4117 18.312C15.695 18.312 18.3566 15.6503 18.3566 12.367C18.3566 9.08375 15.695 6.42212 12.4117 6.42212C9.12843 6.42212 6.4668 9.08375 6.4668 12.367C6.4668 15.6503 9.12843 18.312 12.4117 18.312Z"
                fill="white"
              />
              <path
                d="M13.6645 15.183C13.5412 15.1833 13.4191 15.1592 13.3052 15.1119C13.1913 15.0646 13.088 14.9952 13.0012 14.9077L10.498 12.4046C10.3322 12.2266 10.2419 11.9913 10.2462 11.7481C10.2505 11.5049 10.349 11.2729 10.521 11.1009C10.693 10.9289 10.925 10.8304 11.1682 10.8261C11.4114 10.8218 11.6467 10.9121 11.8247 11.0779L13.6645 12.9165L19.259 7.32322C19.4369 7.15741 19.6723 7.06714 19.9154 7.07144C20.1586 7.07573 20.3906 7.17424 20.5626 7.34622C20.7346 7.5182 20.8331 7.75022 20.8374 7.9934C20.8417 8.23658 20.7514 8.47193 20.5856 8.64988L14.3278 14.9077C14.241 14.9952 14.1376 15.0646 14.0238 15.1119C13.9099 15.1592 13.7878 15.1833 13.6645 15.183Z"
                fill="#572575"
              />
            </svg>
          </Grid>
          <Grid item>
            <Typography
              variant="body2"
              sx={{
                color: "#161719",
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: "14px",
                spacing: "3.14px",
              }}
            >
              Psychometric Test Overview
            </Typography>
          </Grid>
        </Grid>

        {/* CONTENT */}
        <Grid container mt={2} fontFamily={"Inter"}>
          {/* LEFT SIDE */}
          <Grid item xs={7}>
            <Typography
              fontWeight="400"
              color="#000000"
              sx={{ fontSize: "28px", fontFamily: "Inter" }}
            >
              Discover Your True
            </Typography>

            <Typography
              variant="h5"
              fontWeight="400"
              color="#9D0385"
              sx={{ mb: 1, fontSize: "28px", fontFamily: "Inter" }}
            >
              potentional
            </Typography>

            <Typography
              color="#313439"
              fontSize="18px"
              fontWeight="500"
              sx={{ mb: 1 }}
            >
              Start with Self-Discovery
            </Typography>

            <Typography
              fontSize="12px"
              sx={{ mb: 2, color: "#3F424C", maxWidth: "75%" }}
            >
              Your journey begins with our Psychometric Test — a deep dive into
              what makes you, so we can help build the perfect career for your
              future.
            </Typography>

            {/* Duration & Fee */}
            <Grid
              container
              spacing={6}
              sx={{ mb: 2, fontFamily: "Inter" }}
            >
              {/* Duration */}
              <Grid item>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    {/* SVG Icon */}
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
                        fill="#572575"
                      />
                      <path
                        d="M18.4011 18.0047C18.142 18.0046 17.8899 17.9204 17.6827 17.7647L11.2827 12.9647C11.1337 12.8529 11.0127 12.708 10.9294 12.5413C10.8461 12.3747 10.8027 12.191 10.8027 12.0047V4.00469C10.8027 3.68643 10.9292 3.3812 11.1542 3.15616C11.3792 2.93112 11.6845 2.80469 12.0027 2.80469C12.321 2.80469 12.6262 2.93112 12.8513 3.15616C13.0763 3.3812 13.2027 3.68643 13.2027 4.00469V11.4047L19.1227 15.8447C19.3243 15.9959 19.4732 16.2067 19.5483 16.4473C19.6233 16.6878 19.6207 16.9459 19.5409 17.1849C19.4611 17.4239 19.308 17.6317 19.1034 17.7789C18.8988 17.926 18.6531 18.005 18.4011 18.0047Z"
                        fill="white"
                      />
                    </svg>
                  </Grid>
                  <Grid item>
                    <Typography
                      color="#5F6570"
                      fontSize="14px"
                      fontWeight="400"
                    >
                      Duration
                    </Typography>
                    <Typography
                      fontSize="14px"
                      fontWeight="400"
                      color="#161719"
                    >
                      15-20 mins
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              {/* Test Fee */}
              <Grid item>
                <Grid container alignItems="center" spacing={2}>
                  <Grid item>
                    <svg
                      width="20"
                      height="25"
                      viewBox="0 0 20 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 1.22682V18.4364C20 18.7613 19.8711 19.073 19.6417 19.303L14.4237 24.5327C14.1935 24.7634 13.8811 24.893 13.5552 24.893H1.22682C0.549264 24.893 0 24.3437 0 23.6662V1.22682C3.88953e-06 0.549264 0.549268 0 1.22682 0H18.7732C19.4507 0 20 0.549264 20 1.22682Z"
                        fill="#572575"
                      />
                      <path
                        d="M16.8515 5.1837H8.70878C8.4336 5.1837 8.21093 4.96102 8.21093 4.68584C8.21093 4.41066 8.4336 4.18798 8.70878 4.18798H16.8515C17.1267 4.18798 17.3494 4.41066 17.3494 4.68584C17.3494 4.96102 17.1267 5.1837 16.8515 5.1837ZM16.8515 10.3578H8.70878C8.4336 10.3578 8.21093 10.1351 8.21093 9.85989C8.21093 9.58471 8.4336 9.36203 8.70878 9.36203H16.8515C17.1267 9.36203 17.3494 9.58471 17.3494 9.85989C17.3494 10.1351 17.1267 10.3578 16.8515 10.3578ZM16.8515 15.5328H8.70878C8.4336 15.5328 8.21093 15.3101 8.21093 15.0349C8.21093 14.7597 8.4336 14.5371 8.70878 14.5371H16.8515C17.1267 14.5371 17.3494 14.7597 17.3494 15.0349C17.3494 15.3101 17.1267 15.5328 16.8515 15.5328ZM16.8515 20.7068H8.70878C8.4336 20.7068 8.21093 20.4841 8.21093 20.209C8.21093 19.9338 8.4336 19.7111 8.70878 19.7111H16.8515C17.1267 19.7111 17.3494 19.9338 17.3494 20.209C17.3494 20.4841 17.1267 20.7068 16.8515 20.7068ZM5.49468 21.5664H3.52134C3.31647 21.5664 3.15039 21.4003 3.15039 21.1954V19.2221C3.15039 19.0172 3.31647 18.8511 3.52134 18.8511H5.49468C5.69955 18.8511 5.86563 19.0172 5.86563 19.2221V21.1954C5.86563 21.4003 5.69955 21.5664 5.49468 21.5664ZM5.49468 16.392H3.52134C3.31647 16.392 3.15039 16.226 3.15039 16.0211V14.0478C3.15039 13.8429 3.31647 13.6768 3.52134 13.6768H5.49468C5.69955 13.6768 5.86563 13.8429 5.86563 14.0478V16.0211C5.86563 16.226 5.69955 16.392 5.49468 16.392ZM5.49468 11.2177H3.52134C3.31647 11.2177 3.15039 11.0516 3.15039 10.8468V8.87342C3.15039 8.66855 3.31647 8.50246 3.52134 8.50246H5.49468C5.69955 8.50246 5.86563 8.66854 5.86563 8.87342V10.8468C5.86563 11.0516 5.69955 11.2177 5.49468 11.2177ZM5.49468 6.04337H3.52134C3.31647 6.04337 3.15039 5.87729 3.15039 5.67242V3.69908C3.15039 3.49421 3.31647 3.32812 3.52134 3.32812H5.49468C5.69955 3.32812 5.86563 3.4942 5.86563 3.69908V5.67242C5.86563 5.87729 5.69955 6.04337 5.49468 6.04337Z"
                        fill="white"
                      />
                      <path
                        d="M19.8799 18.9453C19.8265 19.079 19.7463 19.1993 19.6393 19.3063L14.4254 24.5335C14.3185 24.6405 14.1981 24.7207 14.0645 24.7742V19.8678C14.0645 19.3597 14.4789 18.9453 14.9869 18.9453L19.8799 18.9453Z"
                        fill="#EECB90"
                      />
                    </svg>
                  </Grid>
                  <Grid item>
                    <Typography
                      color="#5F6570"
                      fontSize="14px"
                      fontWeight="400"
                    >
                      Test Fee
                    </Typography>
                    <Typography
                      fontSize="14px"
                      fontWeight="400"
                      color="#161719"
                    >
                      Rs. 750/only
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* RIGHT SIDE */}
          <Grid item xs={5} textAlign="center">
            <Grid
              component="img"
              src={psychometricPhoto}
              alt="Illustration"
              sx={{
                width: "100%",
                height: "auto",
                border: "1px solid #eee",
                borderRadius: "8px",
                mb: 2,
              }}
            />
          </Grid>
        </Grid>

        {/* Guidelines Section */}
        <Grid
          container
          sx={{
            position: "relative",
            border: "1px solid #DEDEDE",
            bgcolor: "#F9F4FF",
            borderRadius: "12px",
            p: 1,
            alignItems: "center",
          }}
        >
          {/* Floating Label */}
          <Grid
            item
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              transform: "translateY(-10%)",
              bgcolor: "#D6A25D",
              borderTopLeftRadius: "6px",
              borderBottomRightRadius: "6px",
              zIndex: 1,
              px: 2,
              py: 0.5,
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: "16px",
              }}
            >
              Test Guidelines
            </Typography>
          </Grid>

          {/* Left Content */}
          <Grid
            item
            xs={12}
            md={8}
            sx={{ color: "#313439", fontSize: "14px", fontWeight: 400 }}
          >
            <Typography>• Find a quiet place with no distractions.</Typography>
            <Typography>
              • Be honest - there is no right or wrong answer.
            </Typography>
            <Typography>
              • Read each question carefully before answer.
            </Typography>
            <Typography>
              • Do not refresh or close the window during the test.
            </Typography>
          </Grid>

          {/* Right Purple Card */}
          <Grid item xs={12} md={4} sx={{ display: "flex" }}>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              spacing={0}
              sx={{
                bgcolor: "#572575",
                borderRadius: "12px",
                px: 1,
                py: 4,
                color: "#fff",
                textAlign: "center",
                height: "100%",
                width: "80%",
              }}
            >
              <Grid item>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "14px",
                    mb: 2,
                    maxWidth: 200,
                    mx: "auto",
                  }}
                >
                  Give Psychometric Test & discover yourself
                </Typography>
              </Grid>

              <Grid item>
                <Button
                  disabled
                  sx={{
                    bgcolor: "#fff",
                    color: "#000",
                    "&:hover": { bgcolor: "#fff" },
                    borderRadius: "8px",
                    px: 3,
                    fontWeight: 700,
                  }}
                >
                  Start Now
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
}
